var _path, _rect, _g, _path2, _path3, _rect2, _g2, _path4, _path5, _rect3, _g3, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumansIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 401,
    viewBox: "0 0 429 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.262 267.637C421.075 277.277 415.678 288.904 404.885 312.159L398.143 326.684C386.034 352.774 379.979 365.82 369.822 374.935C360.887 382.954 349.814 388.888 338.188 391.888C324.97 395.299 310.748 393.12 282.304 388.762L268.163 386.595C242.811 382.711 230.135 380.769 222.552 374.757C219.096 372.018 216.363 368.707 214.432 364.973L214.382 365L203.339 345.714L213.149 340.408C215.566 332.748 220.096 322.988 226.564 309.052L237.15 286.247C247.914 263.055 253.296 251.459 262.324 243.356C270.266 236.229 280.109 230.954 290.444 228.287C302.193 225.256 314.834 227.192 340.118 231.066L363.287 234.616C378.668 236.973 389.383 238.614 397.126 240.884L406.682 235.714L416.567 255.399C418.631 259.089 419.889 263.219 420.262 267.637Z",
    fill: "#0689BA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1469_3751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 206,
    width: 212,
    height: 169
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 171.429,
    height: 171.429,
    rx: 45.7143,
    transform: "matrix(-0.988247 -0.152869 -0.421004 0.907059 425.884 226.205)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1469_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.96 205.729L388.288 220.476C398.516 222.058 406.013 227.287 409.867 234.462C413.721 241.637 413.931 250.759 409.583 260.125L369.063 347.426C364.716 356.793 356.634 364.632 347.082 369.733C337.53 374.835 326.508 377.199 316.28 375.617L220.952 360.871C210.725 359.289 203.227 354.06 199.373 346.885C195.519 339.709 195.31 330.588 199.657 321.221L240.177 233.92C244.524 224.554 252.606 216.715 262.158 211.613C271.71 206.512 282.732 204.147 292.96 205.729Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.027 317.625L233.812 316.355C226.706 315.255 218.496 319.64 215.476 326.148L211.984 333.671C208.963 340.179 212.275 346.346 219.382 347.445L227.596 348.716C234.703 349.815 242.912 345.43 245.933 338.922L249.426 331.397C252.447 324.889 249.133 318.724 242.027 317.625ZM241.792 338.282C239.747 342.688 234.167 345.668 229.356 344.924L221.142 343.653C216.331 342.909 214.08 338.717 216.125 334.311L219.617 326.786C221.662 322.38 227.242 319.4 232.053 320.144L240.268 321.415C245.079 322.159 247.33 326.351 245.285 330.757L241.792 338.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.577 326.295L229.291 324.858C227.661 324.606 225.776 325.613 225.083 327.106L221.136 335.609C220.443 337.103 221.204 338.518 222.834 338.771L232.12 340.207C233.75 340.459 235.635 339.453 236.328 337.959L240.275 329.456C240.968 327.963 240.207 326.547 238.577 326.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.893 216.883L279.678 215.613C272.572 214.513 264.362 218.898 261.342 225.406L257.85 232.929C254.829 239.437 258.141 245.604 265.248 246.703L273.462 247.974C280.569 249.073 288.778 244.689 291.799 238.18L295.291 230.658C298.311 224.15 294.999 217.983 287.893 216.883ZM287.658 237.54C285.613 241.946 280.033 244.926 275.222 244.182L267.008 242.911C262.197 242.167 259.946 237.975 261.991 233.569L265.482 226.047C267.527 221.641 273.107 218.661 277.918 219.405L286.133 220.675C290.944 221.42 293.195 225.611 291.15 230.017L287.658 237.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.443 225.553L275.157 224.117C273.527 223.864 271.642 224.871 270.949 226.364L267.002 234.868C266.309 236.361 267.07 237.777 268.7 238.029L277.986 239.465C279.616 239.717 281.501 238.711 282.194 237.218L286.141 228.714C286.834 227.221 286.073 225.805 284.443 225.553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.755 233.9L382.541 232.629C375.434 231.53 367.225 235.914 364.204 242.423L360.712 249.945C357.692 256.453 361.004 262.62 368.11 263.72L376.324 264.99C383.431 266.089 391.641 261.705 394.661 255.197L398.153 247.674C401.174 241.166 397.861 234.999 390.755 233.9ZM390.521 254.556C388.476 258.962 382.896 261.942 378.085 261.198L369.87 259.927C365.059 259.183 362.808 254.992 364.853 250.586L368.345 243.063C370.39 238.657 375.97 235.677 380.781 236.421L388.995 237.692C393.806 238.436 396.057 242.628 394.012 247.034L390.521 254.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.305 242.569L378.019 241.133C376.389 240.881 374.504 241.887 373.811 243.38L369.864 251.884C369.171 253.377 369.932 254.793 371.562 255.045L380.848 256.482C382.478 256.734 384.363 255.727 385.056 254.234L389.003 245.73C389.696 244.237 388.935 242.822 387.305 242.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.793 286.502C350.291 287.197 354.872 284.624 356.654 280.785C358.436 276.945 356.444 273.235 352.251 272.587C348.059 271.938 343.242 274.595 341.46 278.434C339.678 282.274 341.417 285.825 345.793 286.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.208 320.081C334.706 320.776 339.287 318.203 341.069 314.364C342.851 310.524 340.859 306.814 336.666 306.166C332.473 305.517 327.657 308.174 325.875 312.013C324.093 315.853 325.831 319.404 330.208 320.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.621 353.662C319.119 354.358 323.7 351.784 325.482 347.945C327.264 344.105 325.272 340.396 321.079 339.747C316.887 339.099 312.07 341.755 310.288 345.595C308.506 349.434 310.245 352.985 314.621 353.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.126 289.337C368.624 290.033 373.205 287.46 374.987 283.62C376.77 279.781 374.777 276.071 370.585 275.423C366.392 274.774 361.575 277.431 359.793 281.27C358.011 285.11 359.75 288.66 364.126 289.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.747 339.708C345.245 340.404 349.826 337.831 351.608 333.991C353.39 330.152 351.398 326.442 347.205 325.794C343.013 325.145 338.196 327.802 336.414 331.641C334.632 335.481 336.371 339.031 340.747 339.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.954 356.498C337.452 357.194 342.033 354.62 343.815 350.781C345.598 346.941 343.605 343.232 339.413 342.583C335.22 341.935 330.404 344.591 328.621 348.431C326.839 352.27 328.578 355.821 332.954 356.498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.665 291.947C269.163 292.643 273.744 290.07 275.526 286.23C277.308 282.391 275.316 278.681 271.123 278.032C266.931 277.384 262.114 280.04 260.332 283.88C258.55 287.719 260.289 291.27 264.665 291.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.872 308.737C261.37 309.432 265.951 306.859 267.733 303.019C269.515 299.18 267.523 295.47 263.331 294.822C259.138 294.173 254.321 296.83 252.539 300.669C250.757 304.509 252.496 308.06 256.872 308.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.122 272.321C258.62 273.017 263.201 270.444 264.983 266.604C266.765 262.765 264.773 259.055 260.58 258.407C256.388 257.758 251.571 260.414 249.789 264.254C247.98 268.15 249.748 271.645 254.122 272.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.329 289.111C250.827 289.807 255.408 287.233 257.19 283.394C258.972 279.554 256.98 275.845 252.787 275.196C248.595 274.548 243.778 277.204 241.996 281.043C240.188 284.94 241.955 288.434 246.329 289.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.502 257.211L307.127 298.955L295.398 297.141L314.773 255.397L304.745 253.845L261.19 347.686L271.159 349.228L291.411 305.592L303.14 307.407L282.887 351.042L292.854 352.584L336.409 258.743L326.502 257.211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.75 249.388C328.248 250.084 332.829 247.511 334.612 243.671C336.394 239.832 334.401 236.122 330.209 235.474C326.016 234.825 321.2 237.481 319.418 241.321C317.609 245.217 319.374 248.711 323.75 249.388Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.91 304.964L383.745 313.936C372.967 337.159 367.577 348.77 358.536 356.879C350.584 364.011 340.728 369.285 330.382 371.946C318.621 374.97 305.97 373.013 280.669 369.099L270.893 367.587",
    stroke: "url(#paint0_radial_1469_3751)",
    strokeOpacity: 0.5,
    strokeWidth: 2.85714
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.952 60.8737C415.683 69.5496 410.826 80.014 401.112 100.943L395.045 114.016C384.146 137.497 378.697 149.238 369.555 157.442C361.514 164.659 351.549 169.999 341.085 172.699C329.189 175.769 316.389 173.808 290.79 169.886L278.062 167.936C255.246 164.44 243.837 162.692 237.012 157.281C233.902 154.816 231.442 151.836 229.704 148.476L229.66 148.5L219.721 131.143L228.55 126.367C230.725 119.474 234.802 110.689 240.624 98.1471L250.151 77.6219C259.838 56.7496 264.682 46.3135 272.808 39.0208C279.956 32.6059 288.814 27.8588 298.115 25.4586C308.689 22.7301 320.067 24.4733 342.822 27.9596L363.674 31.1544C377.517 33.2753 387.161 34.7528 394.129 36.7953L402.73 32.1429L411.624 49.8568C413.483 53.1787 414.616 56.8962 414.952 60.8737Z",
    fill: "#7B4071"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1469_3751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 216,
    y: 6,
    width: 191,
    height: 152
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 154.286,
    height: 154.286,
    rx: 41.1429,
    transform: "matrix(-0.988247 -0.152869 -0.421004 0.907059 420.011 23.5848)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1469_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.302 5.73345L385.645 18.935C394.802 20.3514 401.51 25.0405 404.955 31.4766C408.399 37.9126 408.579 46.0957 404.678 54.4999L368.321 132.832C364.42 141.236 357.177 148.271 348.62 152.851C340.063 157.43 330.191 159.555 321.035 158.138L235.691 144.937C226.535 143.52 219.826 138.831 216.382 132.395C212.937 125.959 212.757 117.776 216.658 109.372L253.015 31.0396C256.916 22.6354 264.159 15.6006 272.717 11.0211C281.274 6.44149 291.145 4.31707 300.302 5.73345Z",
    fill: "#A15A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.158 99.0961L339.236 97.716L341.136 93.6223L350.058 95.0025L348.158 99.0961ZM352.618 99.786L354.518 95.6924L351.958 90.9088L343.036 89.5287L336.676 92.9324L334.776 97.026L325.795 95.6369L314.393 120.203L350.194 125.741L361.596 101.175L352.616 99.7857L352.618 99.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.867 89.5481L343.862 84.7355L325.939 51.2456L315.15 49.5765L301.655 82.5942L294.361 86.5281L291.454 81.0161L308.363 48.5268L297.574 46.8577L253.046 70.6875L256.668 77.4519L292.199 58.4369L278.571 87.7985L258.497 131.049L267.419 132.429L285.594 93.2724L296.115 94.8998L277.94 134.056L286.863 135.437L306.937 92.1864L320.565 62.8248L334.867 89.5481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.575 42.8482C318.576 43.4671 322.704 41.1814 324.312 37.7172C325.92 34.253 324.147 30.9405 320.373 30.3567C316.598 29.7729 312.308 32.1474 310.7 35.6116C309.092 39.0758 310.685 42.2464 314.575 42.8482Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M385.834 94.4673L382.087 102.542C372.386 123.443 367.535 133.893 359.398 141.191C352.241 147.61 343.371 152.357 334.06 154.751C323.475 157.473 312.089 155.712 289.318 152.19L280.52 150.829",
    stroke: "url(#paint1_radial_1469_3751)",
    strokeOpacity: 0.5,
    strokeWidth: 2.57143
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70841 148.088C6.89512 157.728 12.2919 169.355 23.0855 192.61L30.476 208.533C42.5853 234.623 48.6399 247.668 58.7968 256.783C67.7312 264.802 78.8037 270.736 90.4303 273.736C103.648 277.147 117.869 274.968 146.313 270.611L158.924 268.679C184.277 264.796 196.954 262.854 204.537 256.842C209.044 253.269 212.322 248.725 214.195 243.538L224.772 221.538L210.95 214.362C208.402 208.107 204.908 200.581 200.525 191.136L189.291 166.933C178.527 143.742 173.145 132.147 164.117 124.044C156.175 116.916 146.333 111.642 135.998 108.975C124.249 105.943 111.608 107.879 86.3247 111.752L64.6858 115.067C49.7005 117.363 39.1439 118.98 31.45 121.16L21.5974 116.044L12.5827 133.92C9.81638 138.078 8.14755 142.883 7.70841 148.088Z",
    fill: "#DFAE16"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1469_3751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 86,
    width: 212,
    height: 169
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 171.429,
    height: 171.429,
    rx: 45.7143,
    transform: "matrix(0.988247 -0.152869 0.421004 0.907059 -6.10352e-05 106.205)",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1469_3751)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181.063,
    height: 181.063,
    rx: 48.2834,
    transform: "matrix(0.988247 -0.152869 0.421004 0.907059 0.88266 106.8)",
    fill: "url(#paint2_linear_1469_3751)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.382 137.211L118.757 178.955L130.486 177.141L111.111 135.397L121.139 133.845L164.694 227.686L154.725 229.228L134.473 185.592L122.744 187.407L142.997 231.042L133.03 232.584L89.4753 138.743L99.382 137.211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.133 129.388C97.6356 130.084 93.0544 127.511 91.2723 123.671C89.4902 119.832 91.4826 116.122 95.6751 115.474C99.8676 114.825 104.684 117.481 106.466 121.321C108.275 125.217 106.51 128.711 102.133 129.388Z",
    fill: "black"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9745 184.964L42.1388 193.936C52.9176 217.159 58.3069 228.77 67.3478 236.878C75.3005 244.011 85.1559 249.285 95.5017 251.946C107.263 254.97 119.914 253.013 145.215 249.099L154.991 247.587",
    stroke: "url(#paint3_radial_1469_3751)",
    strokeOpacity: 0.5,
    strokeWidth: 2.85714
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1469_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(350.727 363.571) rotate(-126.135) scale(55.7189 53.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1469_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(352.37 147.213) rotate(-126.135) scale(50.147 48.179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1469_3751",
    x1: 22.9926,
    y1: 159.668,
    x2: 188.793,
    y2: 80.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECD35"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1469_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.1574 243.571) rotate(-53.8646) scale(55.7189 53.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumansIcons);
export default __webpack_public_path__ + "static/media/humans_icons.13945c8df0873a4650c4a7d0ca23afdc.svg";
export { ForwardRef as ReactComponent };